import { apiClient } from "./client";
import type {
  MarkAllReadResponse,
  NotificationListResponse,
  NotificationRead,
  UnreadCountResponse,
} from "./types";

export interface ListNotificationsParams {
  is_read?: boolean;
  type?: string;
  limit?: number;
  offset?: number;
}

export async function listNotifications(
  params: ListNotificationsParams = {},
): Promise<NotificationListResponse> {
  const cleaned: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null) continue;
    cleaned[key] = value;
  }
  const res = await apiClient.get<NotificationListResponse>("/notifications", {
    params: cleaned,
  });
  return res.data;
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const res = await apiClient.get<UnreadCountResponse>(
    "/notifications/unread-count",
  );
  return res.data;
}

export async function markRead(id: number): Promise<NotificationRead> {
  const res = await apiClient.post<NotificationRead>(
    `/notifications/${id}/read`,
  );
  return res.data;
}

export async function markAllRead(): Promise<MarkAllReadResponse> {
  const res = await apiClient.post<MarkAllReadResponse>(
    "/notifications/read-all",
  );
  return res.data;
}

export async function deleteNotification(id: number): Promise<void> {
  await apiClient.delete(`/notifications/${id}`);
}

export interface BulkUpdateResponse {
  updated: number;
}

export interface BulkDeleteResponse {
  deleted: number;
}

export async function bulkMarkRead(
  ids: number[],
  isRead = true,
): Promise<BulkUpdateResponse> {
  const res = await apiClient.post<BulkUpdateResponse>(
    "/notifications/bulk-read",
    { ids },
    { params: { is_read: isRead } },
  );
  return res.data;
}

export async function bulkDeleteNotifications(
  ids: number[],
): Promise<BulkDeleteResponse> {
  const res = await apiClient.post<BulkDeleteResponse>(
    "/notifications/bulk-delete",
    { ids },
  );
  return res.data;
}
